import { federalTaxIdValidator } from 'redesign/utils/getInputValidation'
import { object, string } from 'yup'

export const UserLoginWithLink = object().shape({
    cpf: string()
        .required('Campo obrigatório')
        .test('cpf', 'Parece que esse CPF não existe, revise os números do documento', (value: string | undefined): boolean =>
            federalTaxIdValidator(value),
        ),
})
